import { type RepReplyView, RepReplyViewSchema } from "../src/rep-reply.ts";

/*
 * What the master inbox's reply box (`inbox-v2/reply-box.tsx`) kept of the compose box (phase 1 of
 * docs/2026-09-23-compose-view-shape.md): the event that opens it, and the reply view the agent's
 * item reads (`agent/agent-item.tsx`).
 */

/** A reply agent card asks for the reply box ("Write the reply yourself"), which opens on it. */
export const OPEN_COMPOSE_EVENT = "booked:open-compose";

export async function fetchReplyView(planApi: string): Promise<RepReplyView> {
  const response = await fetch(`${planApi}/reply`, { credentials: "same-origin" });
  if (!response.ok) throw new Error(`Could not read the reply view (HTTP ${response.status}).`);
  return RepReplyViewSchema.parse(await response.json());
}
